export enum SettingsActionTypes {
	SUBSCRIBE_SETTINGS_FILED = "SUBSCRIBE_SETTINGS_FILED",
	UNSUBSCRIBE_SETTINGS_FILED = "UNSUBSCRIBE_SETTINGS_FILED",
	UPDATE_SETTINGS_FILED = "UPDATE_SETTINGS_FILED",
}